import { createEvent, restore, sample } from 'effector'
import { EditPromoCode, EditPromoCodePayload, PromoCodeByID } from './types'
import { fx, path } from '../../../../libs'
import { $params, toPath } from '../../../../features/router'
import {
  setRequestError,
  setRequestSuccess,
} from '../../../../features/notifications'

export const promoCodeMounted = createEvent()

export const setPromoCode = createEvent<EditPromoCode>()

export const submitEditPromoCode = createEvent<EditPromoCodePayload>()

export const $promoCode = restore(setPromoCode, {
  bonusPercent: '',
  expiresAt: '',
  isDisabled: false,
})

export const getPromoCode = fx<void, PromoCodeByID>({
  method: 'GET',
  url: '/deposit_bonus/promo_code/{promoCodeID}',
})

export const editPromoCode = fx<EditPromoCodePayload, void>({
  method: 'PUT',
  url: '/deposit_bonus/promo_code/{promoCodeID}',
})

sample({
  clock: promoCodeMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.promoCodeID
    }
    return {
      url: `/deposit_bonus/promo_code/${id}`,
    }
  },
  target: getPromoCode,
})

sample({
  clock: submitEditPromoCode,
  source: $params,
  fn: (params, promoCode) => {
    let id
    if (promoCode.id) {
      id = promoCode.id
    } else if (params) {
      id = params.promoCodeID
    }
    const { id: _, ...bodyWithoutId } = promoCode
    return {
      url: `/deposit_bonus/promo_code/${id}`,
      body: { ...bodyWithoutId },
    }
  },
  target: editPromoCode,
})

sample({
  // @ts-ignore
  clock: [getPromoCode.doneData],
  fn: (doneData) => ({
    bonusPercent: doneData.body.bonusPercent,
    expiresAt: doneData.body.expiresAt,
    isDisabled: Boolean(doneData.body.disabledAt),
  }),
  target: [setPromoCode],
})

sample({
  clock: editPromoCode.doneData,
  fn: () => true,
  target: setRequestSuccess,
})

sample({
  clock: editPromoCode.doneData,
  target: toPath.prepend(path.depositBonus.promoCodes.entry),
})

sample({
  clock: editPromoCode.failData,
  fn: (failData: any) => ({
    message:
      failData?.body?.message || failData?.message || 'Unknown error',
    code: failData?.status ?? 0,
  }),
  target: setRequestError,
})
